<template>
  <div ref="teacherDashboard" class="w-full">
    <grades @selectedGrade="selectedGrade" :isCardActive="isGradesViewActive" @updateBreadcrumbs="updateBreadcrumbs"/>
    <grade-subject @selectedGradeSubject="selectedGradeSubject" :isCardActive="isGradeSubjectViewActive" @updateBreadcrumbs="updateBreadcrumbs" :userDetails="selectedStudentData"/>
    <classroom @selectedClassroomStudentList="selectedClassroomStudentList" @selectedClassroomModule="selectedClassroomModule" :isCardActive="isClassroomViewActive" @updateBreadcrumbs="updateBreadcrumbs" :userDetails="selectedStudentData"/>
    <module-category :isCardActive="isModuleCategoryViewActive" @updateBreadcrumbs="updateBreadcrumbs" :userDetails="selectedStudentData"/>
    <students @selectedStudent="selectedStudent" :userDetails="selectedStudentData" :isCardActive="isStudentsViewActive" @updateBreadcrumbs="updateBreadcrumbs"/>
    <!-- <subjects @selectedSubject="selectedSubject" :userDetails="selectedStudentData" :isCardActive="isSubjectsViewActive" @updateBreadcrumbs="updateBreadcrumbs"/> -->
    <modules @selectedModule="selectedModule" :userDetails="selectedStudentData" :isCardActive="isModulesViewActive" @updateBreadcrumbs="updateBreadcrumbs"/>
    <topics @selectedTopic="selectedTopic" :userDetails="selectedStudentData" :isCardActive="isTopicsViewActive" @updateBreadcrumbs="updateBreadcrumbs"/>
    <tasks @selectedTask="selectedTask" @updateBreadcrumbs="updateBreadcrumbs" :isCardActive="isTasksViewActive" :userDetails="selectedStudentData"/>
    <task-details :userDetails="selectedStudentData" :isCardActive="isTaskDetailViewActive" @updateBreadcrumbs="updateBreadcrumbs"/>
  </div>
</template>


<script>
import VueApexCharts from 'vue-apexcharts'
import Students from './components/Students.vue'
import Subjects from './components/Subjects.vue'
import Modules from './components/Modules.vue'
import Topics from './components/Topics.vue'
import Tasks from './components/Tasks.vue'
import Grades from './components/Grades.vue'
import TaskDetails from './components/TaskDetails.vue'
import DoubleSlider from './components/DoubleSlider.vue'
import GradeSubject from './components/GradeSubject.vue'
import Classroom from './components/Classroom.vue'
import ModuleCategory from './components/ModuleCategory.vue'

export default {
  name: "TeacherDashboard",
  components: {
    VueApexCharts,
    Students,
    DoubleSlider,
    Subjects,
    Modules,
    Topics,
    Tasks,
    TaskDetails,
    Grades,
    GradeSubject,
    Classroom,
    ModuleCategory
  },
  props: {
    subjectViewActive:{
      required:true,
      type:Boolean
    },
  },
  data() {
    return {
      isStudentsViewActive: false,
      isGradesViewActive: true,
      isSubjectsViewActive: false,
      isModulesViewActive: false,
      isTopicsViewActive: false,
      isTasksViewActive: false,
      isTaskDetailViewActive: false,
      isGradeSubjectViewActive : false,
      isClassroomViewActive: false,
      isModuleCategoryViewActive:false,
      selectedStudentData:{},
      name: "TeacherDashboard",
    };
  },
  watch: {

  },
  methods: {
    updateBreadcrumbs(method, breadcrumbsParam) {
      this.$emit("updateBreadcrumbs", method, breadcrumbsParam);
      this.scrollToNavbar();
    },
    selectedGrade(grade){
      this.selectedStudentData = {};
      this.isStudentsViewActive = false;
      this.isModulesViewActive = false;
      this.isTopicsViewActive = false;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = false;
      this.isGradeSubjectViewActive = true
      this.isSubjectsViewActive = false;
      this.isGradesViewActive = false;
      this.selectedStudentData.selectedGrade = grade;
      this.updateBreadcrumbs("add", { text: `${grade.grade.toLowerCase()}`, clickFunction: "backToSubjectGrades", icon: "HomeIcon" });

    },
    selectedStudent(user){
      this.selectedStudentData.selectedStudent = user;
      this.isStudentsViewActive = false;
      this.isModulesViewActive = true;
      this.isTopicsViewActive = false;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = false;
      this.isSubjectsViewActive = false;
      this.updateBreadcrumbs("add", { text: `${user.displayName.toLowerCase()}`, clickFunction: "backToTopics", icon: "UserIcon" });
    },
    selectedModule(module){
      this.isStudentsViewActive = false;
      this.isModulesViewActive = false;
      this.isTopicsViewActive = true;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = false;
      this.isGradeSubjectViewActive = false;
      this.isClassroomViewActive = false;
      this.isSubjectsViewActive = false;
      this.isModuleCategoryViewActive = false;
      this.isGradesViewActive = false;
      this.selectedStudentData.selectedModule = module;
      this.updateBreadcrumbs("add", { text: `${module.moduleCategory.toLowerCase()}`, clickFunction: "backToTopics", icon: "DiscIcon" });
    },
    selectedTopic(topic){
      this.isStudentsViewActive = false;
      this.isModulesViewActive = false;
      this.isTopicsViewActive = false;
      this.isTasksViewActive = true;
      this.isTaskDetailViewActive = false;
      this.isGradeSubjectViewActive = false;
      this.isClassroomViewActive = false;
      this.isSubjectsViewActive = false;
      this.isModuleCategoryViewActive = false;
      this.isGradesViewActive = false;
      this.selectedStudentData.selectedTopic = topic;
      this.updateBreadcrumbs("add", { text: `${topic.name.toLowerCase()}`, clickFunction: "backToTasks", icon: "EditIcon" });
    },
    selectedTask(task){
      this.isSubjectsViewActive = false;
      this.isStudentsViewActive = false;
      this.isModulesViewActive = false;
      this.isTopicsViewActive = false;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = true;
      this.selectedStudentData.selectedTask = task;
      this.updateBreadcrumbs("add", { text: `${task.name.toLowerCase()}`, clickFunction: "backToTasks", icon: "EditIcon" });
    },
    selectedGradeSubject(subject){
      this.isStudentsViewActive = false;
      this.isModulesViewActive = false;
      this.isTopicsViewActive = false;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = false;
      this.isGradeSubjectViewActive = false;
      this.isClassroomViewActive = true;
      this.isSubjectsViewActive = false;
      this.isGradesViewActive = false;
      this.selectedStudentData.selectedGradeSubject = subject;
      this.updateBreadcrumbs("add", { text: `${subject.subject.toLowerCase()}`, clickFunction: "backToClassroom", icon: "UserIcon" });
    },
    selectedClassroomModule(classroom){
      this.isStudentsViewActive = false;
      this.isModulesViewActive = false;
      this.isTopicsViewActive = false;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = false;
      this.isGradeSubjectViewActive = false;
      this.isClassroomViewActive = false;
      this.isSubjectsViewActive = false;
      this.isModuleCategoryViewActive = true;
      this.isGradesViewActive = false;
      this.selectedStudentData.selectedClassroom = classroom;
      this.selectedStudentData.classroomModule = true;
      this.updateBreadcrumbs("add", { text: `${classroom.classroom.toLowerCase()}`, clickFunction: "backToClassroom", icon: "UserIcon" });
    },
    selectedClassroomStudentList(classroom){
      this.isStudentsViewActive = true;
      this.isModulesViewActive = false;
      this.isTopicsViewActive = false;
      this.isTasksViewActive = false;
      this.isTaskDetailViewActive = false;
      this.isGradeSubjectViewActive = false;
      this.isClassroomViewActive = false;
      this.isSubjectsViewActive = false;
      this.isModuleCategoryViewActive = false;
      this.isGradesViewActive = false;
      this.selectedStudentData.selectedClassroom = classroom;
      this.selectedStudentData.classroomStudentList = true;
      this.updateBreadcrumbs("add", { text: `${classroom.classroom.toLowerCase()}`, clickFunction: "backToStudents", icon: "UserIcon" });
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in-out",
        offset: -20,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      this.$scrollTo(
        document.getElementById("navbarGlobal"),
        750,
        scrollOptions
      );
    },
    loadPreviousPos(){
      var progressString = localStorage.getItem("Teacher_Position");
      if(!progressString){
        return
      }
      var progress =  JSON.parse(progressString);
      this.selectedStudentData = progress;
      var activeCard = localStorage.getItem("Active_Card");
      if(!activeCard){
        return
      }
      switch (activeCard) {
        case "1":
          this.selectedGrade(progress.selectedGrade);
          break;
        case "2":
          this.selectedGrade(progress.selectedGrade);
          this.selectedGradeSubject(progress.selectedGradeSubject);
          break;
        case "3":
          this.selectedGrade(progress.selectedGrade);
          this.selectedGradeSubject(progress.selectedGradeSubject);
          this.selectedClassroomModule(progress.selectedClassroom);
          break;
        case "4":
          this.selectedGrade(progress.selectedGrade);
          this.selectedGradeSubject(progress.selectedGradeSubject);
          this.selectedClassroomStudentList(progress.selectedClassroom);
          break;
        case "5":
          this.selectedGrade(progress.selectedGrade);
          this.selectedGradeSubject(progress.selectedGradeSubject);
          this.selectedClassroomStudentList(progress.selectedClassroom);
          this.selectedStudent(progress.selectedStudent);
          break;
        case "6":
          this.selectedGrade(progress.selectedGrade);
          this.selectedGradeSubject(progress.selectedGradeSubject);
          this.selectedClassroomStudentList(progress.selectedClassroom);
          this.selectedStudent(progress.selectedStudent);
          this.selectedModule(progress.selectedModule);
          break;
        case "7":
          this.selectedGrade(progress.selectedGrade);
          this.selectedGradeSubject(progress.selectedGradeSubject);
          this.selectedClassroomStudentList(progress.selectedClassroom);
          this.selectedStudent(progress.selectedStudent);
          this.selectedModule(progress.selectedModule);
          this.selectedTopic(progress.selectedTopic);
          break;
        case "8":
          this.selectedGrade(progress.selectedGrade);
          this.selectedGradeSubject(progress.selectedGradeSubject);
          this.selectedClassroomStudentList(progress.selectedClassroom);
          this.selectedStudent(progress.selectedStudent);
          this.selectedModule(progress.selectedModule);
          this.selectedTopic(progress.selectedTopic);
          this.selectedTask(progress.selectedTask);
          break;
        default:
          break;
      }
    }
  },
  created() {
    
  },
  mounted() {
    this.loadPreviousPos();
  }
};
</script>